import { useId } from 'react'

// A Settings row: label and one line of explanation, a switch at the end.
export function Switch({ label, description, checked, onChange }: {
  label: string
  description?: string
  checked: boolean
  onChange: (next: boolean) => void
}) {
  const id = useId()
  return (
    <div className="ml-switch-row">
      <div className="ml-switch-row__text">
        <span id={`${id}-l`} className="ml-switch-row__label">{label}</span>
        {description && <span id={`${id}-d`} className="ml-switch-row__desc">{description}</span>}
      </div>
      <button type="button" role="switch" aria-checked={checked}
        aria-labelledby={`${id}-l`} aria-describedby={description ? `${id}-d` : undefined}
        className={`ml-switch${checked ? ' is-on' : ''}`} onClick={() => onChange(!checked)}>
        <span className="ml-switch__knob" />
      </button>
    </div>
  )
}
